import apisauce from 'apisauce';
import Cookies from 'js-cookie';
import config from '@/config';

const mtClientInfoStr = Cookies.get('MT_CLIENT_INFO');
const mtClientInfo = mtClientInfoStr ? JSON.parse(mtClientInfoStr) : '';
const devicekey = mtClientInfo ? mtClientInfo.devicekey : '0UDbKMpP91HqSN2rc7aXFyWEhGmk6Y8i';

// import apiObj from './apis';

window.ajaxHeader = {
  token: null
};

export function getToken() {
  if (window.ajaxHeader && window.ajaxHeader.token) {
    return window.ajaxHeader.token;
  } else if (window.localStorage) {
    return window.localStorage.getItem('token');
  }
  return null;
}

// const hrefUrlStr = window.location.href;
// const regUploadUrl = new RegExp('freeClinic/freeQuestion');
// const isUploadUrl = regUploadUrl.test(hrefUrlStr);
export const instance = apisauce.create({
  baseURL: config.otherAjaxPrefix.indexOf(location.hostname) > -1 ? config.ajaxPrefix : '/',
  timeout: 20000,
  headers: {
    Accept: '*/*',  // 因为mobile下的接口返回不是json，这里做此设定
    clientInfo: JSON.stringify({
      clientAppVersion: '1.9.8',       // 客户端版本 （独立版）
      clientYunyuVersion: '',          // 客户端版本 （孕育版）
      clientSystem: window.navigator.userAgent,        // 客户端系统类型(如IOS、安卓)
      clientVersion: '',               // 客户端系统版本(如9.0、10.0)
      deviceCode: devicekey,                  // 客户端标志
      latitude: '',                    // 经度
      longitude: '',                   // 维度
      traderName: '',                  // 手机型号(如iPhone 6s、iPhone7)
      partner: 'babytree',             // 渠道标志
      nettype: 'unknown',              // 网络类型标志(如WIFI、2G、3G、4G)
      clientip: '',                     // 客户端IP
      screenwidth: '',  // 设备分辨率宽度
      screenheight: '' // 设备分辨率高度
    }),
    platform: '1',                     // 平台ID,相当于老版本的apptype
    birthday: '',                      // 宝宝生日
    timestamp: Date.parse(new Date()), // 时间戳(1970年以来的秒数)
    signature: '350F163035D51E8D400114BE70EDFBFA',   // 签名，默认不校验
    protocol: document.location.protocol === 'https:' ? 'https' : 'http',      // 本次请求的用户协议类型
    token: getToken()                   // 专家token
  }
  // transformRequest: [(data, header) => {
  //   debugger;
  //   console.log(arguments);
  //   console.log(data);
  //   console.log(header);
  //   // return data;
  // }],
  // transformResponse: [(data) => {
  //   console.log(arguments);
  //   console.log(data);
  // }],
});

// function makeApi(apis = {}) {
//   const resultApis = {};
//   const { keys, values } = Object;
//   const names = keys(apis);
//   const apisValue = values(apis);
//   const last = name.length;
//   for (let i = 0; i < last; i += 1) {
//     resultApis[names[i]] = (payload, options, post) => {
//       if (post) {
//         return instance.post(apisValue[i], payload, options);
//       }
//       return instance.get(apisValue[i], payload, options);
//     };
//     return resultApis;
//   }
//   return resultApis;
// }
//
// export default makeApi(apiObj);

export function updateAjaxHeaderConfig({ token = null, userInfo }) {
  if (token) {
    window.ajaxHeader.token = token;
  }
  if (window.localStorage) {
    window.localStorage.setItem('token', token);
    if (userInfo) {
      window.localStorage.setItem('userinfo', JSON.stringify(userInfo));
    }
  }
}

// 专家义诊接口使用 mapi, 对应域名也修改为 babytree.com
const buildEnv = process.env.PROJECT_BUILD_ENV;
instance.addRequestTransform((request) => {
  const { url } = request;
  if (/^\/mapi/.test(url) && buildEnv !== 'localhost') {
    let prefix = '//newmapi.babytree-test.com';
    if (buildEnv === 'production') {
      prefix = '//newmapi.babytree.com';
    }
    if (buildEnv === 'preproduction') {
      prefix = '//newmapi.pre.fpm.babytree.com';
    }
    request.url = `${prefix}${url}`;
  } else if (/^\/mobile\/up/.test(url) && buildEnv !== 'localhost') {
    // http://upload.babytree.com/api/mobile_image/upload_images
    // request.url = `//upload.api.babytree.com${url}`;
    request.url = `${buildEnv === 'production' ? '//fileupload.babytree.com' : '//fileupload.babytree-test.com'}${url}`;
  } else if (/^\/account\/login/.test(url) && buildEnv !== 'localhost') {
    request.url = `//openapi.meitun.com${url}`;
  } else if (/^\/openapi\/getTokenByLoginString/.test(url) && buildEnv !== 'localhost') {
    request.url = `//h5proxy.meitun.com/newapi/router${url}`;
  }
});

export default instance;



// WEBPACK FOOTER //
// ./src/comm/api/index.js